var Backbone, EmailFormCallClickView, SupportContactChannelClickTemplate,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportContactChannelClickTemplate = require('../../../../contact_channel_click.html.mustache');

Backbone = require('backbone');

Backbone.$ = $;

EmailFormCallClickView = (function(superClass) {
  extend(EmailFormCallClickView, superClass);

  function EmailFormCallClickView() {
    return EmailFormCallClickView.__super__.constructor.apply(this, arguments);
  }

  EmailFormCallClickView.prototype.className = 'contact-channel-click-container';

  EmailFormCallClickView.prototype.events = {
    'click #returnHome': "returnHome"
  };

  EmailFormCallClickView.prototype.initialize = function(options) {
    this.options = options || {};
    this.I18nScope = 'modules.support';
    this.template = SupportContactChannelClickTemplate;
    this.contactChannelTextView = this.options.contactChannelTextView;
    return this.phoneNumberView = this.options.phoneNumberView;
  };

  EmailFormCallClickView.prototype.render = function() {
    this.$el.html(toHtml(this.template, this.toHash(), this.I18nScope));
    this.phoneNumberView.render();
    this.$el.find(".phone-number-container").html(this.phoneNumberView.el);
    this.contactChannelTextView.render();
    this.contactChannelTextView.$el.removeClass();
    return this.$el.find(".contact-channel-container").html(this.contactChannelTextView.el);
  };

  EmailFormCallClickView.prototype.toHash = function() {
    var hash;
    hash = {
      isCallClicked: true
    };
    return hash;
  };

  EmailFormCallClickView.prototype.returnHome = function() {
    return window.location.href = "/";
  };

  EmailFormCallClickView.prototype.postRenderhandler = function() {
    return this.contactChannelTextView.renderLiveChat();
  };

  return EmailFormCallClickView;

})(Backbone.View);

module.exports = EmailFormCallClickView;

//# sourceMappingURL=data:application/json;base64,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
